export function evaluateStage(score, totalQuestions, stageNumber) {
  const percentage = (score / totalQuestions) * 100;
  
  let nextStage = null;
  let finalLevel = null;
  let shouldContinue = false;
  
  if (percentage >= 80) {
    if (stageNumber < 6) {
      shouldContinue = true;
      nextStage = stageNumber + 1;
    } else {
      finalLevel = 'C2';
    }
  } else if (percentage >= 60) {
    const levels = ['A1', 'A2', 'B1', 'B2', 'C1', 'C2'];
    finalLevel = levels[stageNumber - 1];
  } else {
    if (stageNumber === 1) {
      finalLevel = 'Pre-A1';
    } else {
      const levels = ['A1', 'A2', 'B1', 'B2', 'C1', 'C2'];
      finalLevel = levels[stageNumber - 2];
    }
  }
  
  return {
    percentage: Math.round(percentage),
    score,
    totalQuestions,
    shouldContinue,
    nextStage,
    finalLevel
  };
}

export function calculateSkillBreakdown(answers, questions) {
  const skills = {
    grammar: { correct: 0, total: 0 },
    vocabulary: { correct: 0, total: 0 },
    reading: { correct: 0, total: 0 },
    writing: { correct: 0, total: 0 }
  };
  
  questions.forEach(question => {
    const skill = question.skill || 'grammar';
    
    if (question.type === 'reading_comprehension') {
      question.questions.forEach(subQ => {
        skills[skill].total++;
        if (answers[subQ.id] === subQ.answer) {
          skills[skill].correct++;
        }
      });
    } else if (question.type === 'writing_prompt') {
      skills[skill].total++;
      if (answers[question.id]) {
        skills[skill].correct++;
      }
    } else {
      skills[skill].total++;
      if (answers[question.id] === question.answer) {
        skills[skill].correct++;
      }
    }
  });
  
  return Object.entries(skills)
    .filter(([_, data]) => data.total > 0)
    .map(([skill, data]) => ({
      skill,
      percentage: Math.round((data.correct / data.total) * 100),
      correct: data.correct,
      total: data.total
    }))
    .sort((a, b) => b.percentage - a.percentage);
}

export function shuffleArray(array) {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
}

export function getRecommendations(finalLevel, skillBreakdown) {
  const weakSkills = skillBreakdown.filter(s => s.percentage < 60);
  const strongSkills = skillBreakdown.filter(s => s.percentage >= 80);
  
  const recommendations = [];
  
  if (weakSkills.length > 0) {
    recommendations.push({
      area: 'Obszary do poprawy',
      items: weakSkills.map(s => `${s.skill.charAt(0).toUpperCase() + s.skill.slice(1)} (${s.percentage}%)`),
      suggestion: 'Skup się na tych obszarach w kolejnych lekcjach i ćwiczeniach.'
    });
  }
  
  if (strongSkills.length > 0) {
    recommendations.push({
      area: 'Mocne strony',
      items: strongSkills.map(s => `${s.skill.charAt(0).toUpperCase() + s.skill.slice(1)} (${s.percentage}%)`),
      suggestion: 'Kontynuuj rozwój tych umiejętności.'
    });
  }
  
  return recommendations;
}

export function getMonthsToNextLevel(finalLevel) {
  const levels = ['Pre-A1', 'A1', 'A2', 'B1', 'B2', 'C1', 'C2'];
  const currentIndex = levels.indexOf(finalLevel);
  
  if (currentIndex === -1 || currentIndex === levels.length - 1) {
    return null; // C2 is max level
  }
  
  // Estimate: 3 months per level with regular study
  const monthsEstimate = 3;
  
  return {
    nextLevel: levels[currentIndex + 1],
    months: monthsEstimate,
    currentIndex,
    totalLevels: levels.length
  };
}
